/* ==========================================================================
   Wefty Design — ölçek kademesi → milimetre haritası

   ⚠️ BU DOSYA ELLE DÜZENLENMEZ. `scripts/katalog/olcu_haritasi.py` üretir,
   kaynağı `scripts/katalog/urun_metni.py` içindeki TIP tablosudur.
   Ölçü değişecekse TIP tablosu düzenlenir ve script yeniden çalıştırılır.

   Anahtar: ürünün tip etiketi (küçük harf). `products.json` ürünün `tags`
   dizisini döndürüyor; paket kurucu bu dizide bu anahtarlardan birini arıyor.
   ========================================================================== */

window.WEFTY_OLCULER = {
 "ayaklı kulübe": {
  "ad": "Minyatür Ayaklı Kulübe",
  "eksen": "dikey yükseklik",
  "mm": {
   "L": 29,
   "M": 23,
   "S": 18,
   "XL": 37
  }
 },
 "balıkçı teknesi": {
  "ad": "Minyatür Balıkçı Teknesi",
  "eksen": "yatay boy",
  "mm": {
   "L": 29,
   "M": 23,
   "S": 18,
   "XL": 37
  }
 },
 "bağlama babası": {
  "ad": "Minyatür Bağlama Babası",
  "eksen": "dikey yükseklik",
  "mm": {
   "L": 24,
   "M": 19,
   "S": 15,
   "XL": 30
  }
 },
 "cankurtaran kulesi": {
  "ad": "Minyatür Cankurtaran Kulesi",
  "eksen": "dikey yükseklik",
  "mm": {
   "L": 29,
   "M": 23,
   "S": 18,
   "XL": 37
  }
 },
 "deniz canlısı": {
  "ad": "Minyatür Deniz Canlısı",
  "eksen": "yatay boy",
  "mm": {
   "L": 26,
   "M": 21,
   "S": 17,
   "XL": 33
  }
 },
 "deniz feneri": {
  "ad": "Minyatür Deniz Feneri",
  "eksen": "dikey yükseklik",
  "mm": {
   "L": 29,
   "M": 23,
   "S": 18,
   "XL": 37
  }
 },
 "ev": {
  "ad": "Minyatür Ev",
  "eksen": "dikey yükseklik (çatı dahil)",
  "mm": {
   "L": 28,
   "M": 22,
   "S": 17,
   "XL": 35
  }
 },
 "hamak": {
  "ad": "Minyatür Hamak",
  "eksen": "yatay gergin boy",
  "mm": {
   "L": 26,
   "M": 21,
   "S": 17,
   "XL": 33
  }
 },
 "i̇nsan figürü": {
  "ad": "Minyatür İnsan Figürü",
  "eksen": "dikey boy",
  "mm": {
   "L": 26,
   "M": 21,
   "S": 17,
   "XL": 33
  }
 },
 "i̇skele": {
  "ad": "Minyatür İskele",
  "eksen": "yatay modül boyu",
  "mm": {
   "L": 29,
   "M": 23,
   "S": 18,
   "XL": 37
  }
 },
 "kano": {
  "ad": "Minyatür Kano",
  "eksen": "yatay boy",
  "mm": {
   "L": 29,
   "M": 23,
   "S": 18,
   "XL": 37
  }
 },
 "kaya / mercan": {
  "ad": "Minyatür Kaya / Mercan",
  "eksen": "en uzun kenar",
  "mm": {
   "L": 26,
   "M": 21,
   "S": 17,
   "XL": 33
  }
 },
 "liman aksesuarı": {
  "ad": "Minyatür Liman Aksesuarı",
  "eksen": "en uzun kenar",
  "mm": {
   "L": 25,
   "M": 20,
   "S": 16,
   "XL": 32
  }
 },
 "martı": {
  "ad": "Minyatür Martı",
  "eksen": "yatay kanat açıklığı",
  "mm": {
   "L": 25,
   "M": 20,
   "S": 16,
   "XL": 32
  }
 },
 "motorlu tekne": {
  "ad": "Minyatür Motorlu Tekne",
  "eksen": "yatay boy",
  "mm": {
   "L": 29,
   "M": 23,
   "S": 18,
   "XL": 37
  }
 },
 "oturan figür": {
  "ad": "Minyatür Oturan Figür",
  "eksen": "dikey boy",
  "mm": {
   "L": 25,
   "M": 20,
   "S": 16,
   "XL": 32
  }
 },
 "palmiye": {
  "ad": "Minyatür Palmiye",
  "eksen": "dikey yükseklik",
  "mm": {
   "L": 32,
   "M": 25,
   "S": 20,
   "XL": 40
  }
 },
 "plaj kabini": {
  "ad": "Minyatür Plaj Kabini",
  "eksen": "dikey yükseklik",
  "mm": {
   "L": 28,
   "M": 22,
   "S": 17,
   "XL": 35
  }
 },
 "plaj seti": {
  "ad": "Minyatür Plaj Seti",
  "eksen": "en uzun parça",
  "mm": {
   "L": 26,
   "M": 21,
   "S": 17,
   "XL": 33
  }
 },
 "plaj şemsiyesi": {
  "ad": "Minyatür Plaj Şemsiyesi",
  "eksen": "dikey yükseklik",
  "mm": {
   "L": 26,
   "M": 21,
   "S": 17,
   "XL": 33
  }
 },
 "römorkör": {
  "ad": "Minyatür Römorkör",
  "eksen": "yatay boy",
  "mm": {
   "L": 29,
   "M": 23,
   "S": 18,
   "XL": 37
  }
 },
 "sandal": {
  "ad": "Minyatür Sandal",
  "eksen": "yatay boy",
  "mm": {
   "L": 26,
   "M": 21,
   "S": 17,
   "XL": 33
  }
 },
 "sörf tahtası": {
  "ad": "Minyatür Sörf Tahtası",
  "eksen": "yatay boy",
  "mm": {
   "L": 25,
   "M": 20,
   "S": 16,
   "XL": 32
  }
 },
 "tek katlı ev": {
  "ad": "Minyatür Tek Katlı Ev",
  "eksen": "dikey yükseklik (çatı dahil)",
  "mm": {
   "L": 24,
   "M": 19,
   "S": 15,
   "XL": 30
  }
 },
 "tekne parçası": {
  "ad": "Minyatür Tekne Parçası",
  "eksen": "yatay boy",
  "mm": {
   "L": 26,
   "M": 21,
   "S": 17,
   "XL": 33
  }
 },
 "tiki kulübe": {
  "ad": "Minyatür Tiki Kulübe",
  "eksen": "dikey yükseklik",
  "mm": {
   "L": 28,
   "M": 22,
   "S": 17,
   "XL": 35
  }
 },
 "yat": {
  "ad": "Minyatür Yat",
  "eksen": "yatay boy",
  "mm": {
   "L": 32,
   "M": 25,
   "S": 20,
   "XL": 40
  }
 },
 "yelkenli": {
  "ad": "Minyatür Yelkenli",
  "eksen": "yatay gövde boyu",
  "mm": {
   "L": 30,
   "M": 24,
   "S": 19,
   "XL": 38
  }
 },
 "çapa": {
  "ad": "Minyatür Çapa",
  "eksen": "dikey boy",
  "mm": {
   "L": 24,
   "M": 19,
   "S": 15,
   "XL": 30
  }
 },
 "şamandıra": {
  "ad": "Minyatür Şamandıra",
  "eksen": "dikey yükseklik",
  "mm": {
   "L": 19,
   "M": 15,
   "S": 12,
   "XL": 24
  }
 },
 "şezlong": {
  "ad": "Minyatür Şezlong",
  "eksen": "yatay boy",
  "mm": {
   "L": 25,
   "M": 20,
   "S": 16,
   "XL": 32
  }
 }
};
